<!-- Navbar -->
<nav class="py-2 border-bottom col-lg-10 col-11 mx-auto">
  <div class="d-flex flex-wrap">
    <ul class="nav me-auto">
      <li class="nav-item" [style.background-color]="this.navbarstate === 1 ? 'rgba(255,0,0,0.75)': ''"><a
        (click)="this.navbarstate = 1" class="nav-link link-body-emphasis px-2 pointer">Bewerber</a></li>
      <li class="nav-item" [style.background-color]="this.navbarstate === 2 ? 'rgba(255,0,0,0.75)': ''"><a
        (click)="this.navbarstate = 2" class="nav-link link-body-emphasis px-2 pointer">Unternehmen</a></li>
      <li class="nav-item" *ngIf="this.authHelper.isAuthorized()"
          [style.background-color]="this.navbarstate === 3 ? 'rgba(255,0,0,0.75)': ''"><a
        (click)="this.navbarstate = 3" class="nav-link link-body-emphasis px-2 pointer">Administration</a></li>
    </ul>
    <ul class="nav">
      <li *ngIf="!this.authHelper.isAuthorized()" class="nav-item"><a routerLink="/login"
                                                                      class="nav-link link-body-emphasis px-2">Anmelden</a>
      </li>
      <li *ngIf="this.authHelper.isAuthorized()" class="nav-item" style="cursor: pointer" (click)="this.logout()">
        <span>{{ this.tokenStorage.getUser().username }}</span><span> (Abmelden)</span></li>

      <!--      <li class="nav-item"><a routerLink="/register" class="nav-link link-body-emphasis px-2">Registrieren</a></li>-->
    </ul>
  </div>
</nav>

<header class="py-3 mb-4 border-bottom col-lg-10 col-11 mx-auto">
  <div class="d-flex flex-wrap">
    <div class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto link-body-emphasis text-decoration-none">
      <a routerLink="/startseite">
        <img alt="iLogistix Logo" style="height: 50px; width: 130px" ngSrc="assets/images/ilogistix-logo.png" priority
             height="316" width="788">
      </a>
      <div class="container">
        <ul class="nav me-auto" *ngIf="this.navbarstate === 0 || this.navbarstate === 1">
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2" aria-current="page" routerLink="/startseite">Startseite</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2" routerLink="/jobsuche">Jobsuche</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2" routerLink="/kontakt">Kontakt</a>
          </li>
        </ul>
        <ul class="nav me-auto" *ngIf="this.navbarstate === 2">
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2" aria-current="page" routerLink="/startseite">Startseite</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2"
               routerLink="/unternehmen/mitarbeitersuche">Mitarbeitersuche</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2" routerLink="/kontakt">Kontakt</a>
          </li>
        </ul>
        <ul class="nav me-auto" *ngIf="this.navbarstate === 3">
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2"
               routerLink="/admin/customers">Kunden</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2"
               routerLink="/admin/jobs">Jobs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2"
               routerLink="/admin/recruits">Bewerberprofile</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2"
               routerLink="/admin/filterkategorien">Filterkategorien</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-body-emphasis px-2"
               routerLink="/admin/user">Benutzer</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
<!-- Navbar Ende -->

<router-outlet></router-outlet>

<!-- Footer -->
<div class="border-top mx-auto col-lg-10 col-10">
  <footer class="py-5">
    <div class="row">
      <div class="col-12 col-md-3 mb-4">
        <ul class="nav flex-column">
          <!--          <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-body-secondary">Zeitarbeit</a></li>-->
          <!--          <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-body-secondary">Personalvermittlung</a></li>-->
          <!--          <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-body-secondary">FAQ</a></li>-->
          <!--          <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-body-secondary">Wir stellen ein</a></li>-->
          <li class="nav-item mb-2"><a routerLink="/kontakt" class="nav-link p-0 text-body-secondary">Kontakt</a></li>
          <li class="nav-item mb-2"><a routerLink="/arbeitnehmerueberlassung" class="nav-link p-0 text-body-secondary">Erlaubnis
            zur Arbeitnehmerüberlassung</a></li>
          <li class="nav-item mb-2"><a routerLink="/gvp" class="nav-link p-0 text-body-secondary">Gesamtverband der
            Personaldienstleister Mitgliedsurkunde</a></li>

        </ul>
      </div>

      <div class="col-12 col-md-3 mb-4">
        <ul class="nav flex-column">
          <!--          <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-body-secondary">Über uns</a></li>-->
          <li class="nav-item mb-2"><a routerLink="/agb" class="nav-link p-0 text-body-secondary">AGB</a></li>
          <li class="nav-item mb-2"><a routerLink="/impressum" class="nav-link p-0 text-body-secondary">Impressum</a>
          </li>
          <li class="nav-item mb-2"><a routerLink="/datenschutz" class="nav-link p-0 text-body-secondary">Datenschutzerklärung</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
      <p>&copy; 2023-{{ this.date.getFullYear() }} | iLogistix GmbH</p>
      <ul class="list-unstyled d-flex">
        <li class="ms-3">
          <a class="link-body-emphasis" href="#">
            <svg class="bi" width="24" height="24" viewBox="426.896 102.499 170.207 200">
              <path
                d="M442.394 142c-1.736 0-3.197.61-3.934 1.803-.76 1.231-.645 2.818.166 4.424l19.503 33.761c.033.064.033.105 0 .164l-30.648 54.084c-.799 1.592-.76 3.191 0 4.425.736 1.187 2.033 1.966 3.771 1.966h28.844c4.312 0 6.393-2.91 7.867-5.57 0 0 29.973-53.01 31.14-55.068-.118-.19-19.83-34.58-19.83-34.58-1.439-2.557-3.606-5.41-8.03-5.41h-28.849z"
                fill="#005a5f"/>
              <path
                d="M563.574 102.501c-4.309 0-6.176 2.714-7.723 5.494 0 0-62.14 110.2-64.188 113.818.105.196 40.984 75.191 40.984 75.191 1.432 2.558 3.641 5.494 8.06 5.494h28.81c1.738 0 3.096-.654 3.828-1.843.77-1.23.748-2.857-.059-4.458l-40.664-74.295a.167.167 0 0 1 0-.189l63.863-112.92c.803-1.594.82-3.22.061-4.452-.736-1.188-2.098-1.843-3.836-1.843h-29.139v.002h.003z"
                fill="#d4d600"/>
            </svg>
          </a>
        </li>
        <li class="ms-3">
          <a class="link-body-emphasis" href="https://www.linkedin.com/company/ilogistix-gmbh">
            <svg class="bi" width="24" height="24" viewBox="0 0 256 256">
              <g fill="none">
                <path
                  d="M0 18.338C0 8.216 8.474 0 18.92 0h218.16C247.53 0 256 8.216 256 18.338v219.327C256 247.79 247.53 256 237.08 256H18.92C8.475 256 0 247.791 0 237.668V18.335z"
                  fill="#069"/>
                <path
                  d="M77.796 214.238V98.986H39.488v115.252H77.8zM58.65 83.253c13.356 0 21.671-8.85 21.671-19.91-.25-11.312-8.315-19.915-21.417-19.915-13.111 0-21.674 8.603-21.674 19.914 0 11.06 8.312 19.91 21.169 19.91h.248zM99 214.238h38.305v-64.355c0-3.44.25-6.889 1.262-9.346 2.768-6.885 9.071-14.012 19.656-14.012 13.858 0 19.405 10.568 19.405 26.063v61.65h38.304v-66.082c0-35.399-18.896-51.872-44.099-51.872-20.663 0-29.738 11.549-34.78 19.415h.255V98.99H99.002c.5 10.812-.003 115.252-.003 115.252z"
                  fill="#fff"/>
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</div>
<!-- Footer -->
